__turbopack_context__.v({
  "arrowIcon": "PlaylistSlider-module__A82qLq__arrowIcon",
  "cardWrapper": "PlaylistSlider-module__A82qLq__cardWrapper",
  "left": "PlaylistSlider-module__A82qLq__left",
  "navButton": "PlaylistSlider-module__A82qLq__navButton",
  "right": "PlaylistSlider-module__A82qLq__right",
  "sliderContainer": "PlaylistSlider-module__A82qLq__sliderContainer",
  "sliderWrapper": "PlaylistSlider-module__A82qLq__sliderWrapper",
});
